import { render, staticRenderFns } from "./AppointmentsOverview.vue?vue&type=template&id=5c07730b&scoped=true&"
import script from "./AppointmentsOverview.vue?vue&type=script&lang=js&"
export * from "./AppointmentsOverview.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsOverview.vue?vue&type=style&index=0&id=5c07730b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c07730b",
  null
  
)

export default component.exports